(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("oimo"), require("dat.gui"), require("three"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([, , , ], factory);
	else if(typeof exports === 'object')
		exports["VueThreejs"] = factory(require("oimo"), require("dat.gui"), require("three"), require("vue"));
	else
		root["VueThreejs"] = factory(root["OIMO"], root["dat"], root["THREE"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__4313__, __WEBPACK_EXTERNAL_MODULE__4e1b__, __WEBPACK_EXTERNAL_MODULE__5fda__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 